// Repsonsive nav
$(window).on("resize", function () {
    if ($(window).width() >= 767) {
        $('ul.nav li.dropdown').removeClass('open');
        $('ul.nav li.dropdown').hover(function () {
            $(this).addClass('open');
        },
            function () {
                $(this).removeClass('open');
            });
    } else {
        $('ul.nav li.dropdown a.dropdown-toggle').click(function (e) {
            $(this).parent().toggleClass('open');
        });
        $('.dropdown .dropdown-toggle').click(function (e) {
            e.preventDefault();
        });
    }
}).resize();


// Sub dropdown
$(function () {
    $('.dropdown-menu li:has(.dropdown)').toggleClass('sub-dropdown');

    // Handle clicks on the first submenu 
    $('.sub-dropdown a:not(.sub-dropdown li a)').click(function (e) {

        e.stopPropagation();
        e.preventDefault();

        var isAlreadyOpen = $(this).parent().hasClass('sub-dropdown--active');
        if (isAlreadyOpen) {        // Just close 
            $(this).parent().removeClass('sub-dropdown--active');
            $(this).next().removeClass('dropdown--open');
        } else {
            $('.nav.navbar-nav .submenu2.dropdown--open').removeClass('dropdown--open');
            //$(this).find('sub-dropdown--active').removeClass('sub-dropdown--active');
            $('li.sub-dropdown--active').removeClass('sub-dropdown--active');

            $(this).parent().addClass('sub-dropdown--active');
            $(this).parent().find('.dropdown').first().addClass('dropdown--open');
        }


    });
    // Handle clicks on the 2nd and third submenus
    $('.nav.navbar-nav').on('click', '.submenu2li.sub-dropdown:not(.submenu3li a) a:not(.parentLink)', function (e) {

        //console.log('.submenu2li.sub-dropdown a');

        e.stopPropagation();
        e.preventDefault();

        var isAlreadyOpen = $(this).parent().hasClass('sub-dropdown--active');
        if (isAlreadyOpen) {        // Just close 
            $(this).parent().removeClass('sub-dropdown--active');
            $(this).next().removeClass('dropdown--open');
        } else {
            $('.nav.navbar-nav .dropdown.submenu3.dropdown--open').removeClass('dropdown--open');
            $('.submenu2li.sub-dropdown--active').removeClass('sub-dropdown--active');
            $(this).parent().find('.dropdown').first().toggleClass('dropdown--open');
        }

    });

});


// Accordion
$(function () {
    $('.accordion__title').click(function () {
        $(this).addClass('accordion__title--active');
        $(this).next().toggleClass('accordion__content--active');
        // $(this).parent().toggleClass('accordion-container--active');
    });

    $('.accordion__title.month').click(function (event) {
        event.preventDefault();
        $('.accordion__title.month').removeClass('active')
        $(this).addClass('active');
        $(this).next().toggleClass('active');

    });
});

$(function () {
    $('.faq a.expand').click(function (event) {
        event.preventDefault();

        var rootElement = $(this).parent().parent().parent();

        if (rootElement.find('.FAQAnswerCaption').css('display') == "block") {
            rootElement.find('.FAQAnswerCaption').css('display', 'none');
            rootElement.find('.FAQAnswerFull').css('display', 'block');
            rootElement.find('.faqTitleWrapper').addClass('active');
        } else {
            rootElement.find('.FAQAnswerCaption').css('display', 'block');
            rootElement.find('.FAQAnswerFull').css('display', 'none');
            rootElement.find('.faqTitleWrapper').removeClass('active');
        }
    })
});


// Find a job expand
$(function () {
    $('.job-search__expand').click(function () {
        $(this).parent().toggleClass('job-search--expanded');
    });
});

function goBack() {
    window.history.back();
}

